export default __webpack_public_path__ + "static/media/unmute.3755f76a.svg";